"use client";

import { useMemo } from "react";

/**
 * 价格活动（限时折扣）已下线：
 * - 接口不再返回 item.discount 字段
 * - 相关倒计时与活动价展示不再生效
 *
 * 为了兼容现有调用方（如 RootLayoutClient），
 * 本 Hook 保留导出但始终返回“无活动”的默认值。
 * 后续有活动相关逻辑，会重新启用该 Hook。
 */
export const usePricingActivity = () => {
  const remainingMs = useMemo(() => 0, []);

  return {
    expiredTime: undefined as number | undefined,
    remainingMs,
    price: {
      originPrice: 0,
      monthPrice: 0,
      percent: 0,
    },
  };
};
